<div style="display: flex;justify-content: center; padding-top: 20px ">
  <mat-button-toggle-group name="layout" [(value)]="mode">
    <mat-button-toggle value="manage" (change)="changeMode($event)">
      Manage existing properties
    </mat-button-toggle>
    <mat-button-toggle value="upload" (change)="changeMode($event)">
      Upload new property
    </mat-button-toggle>
  </mat-button-toggle-group>

</div>
<div *ngIf="mode === 'manage'">
  <ng-container *ngIf="project">
    <app-manage-property [project]=project [isPackageProperty]="isPackageProperty" (signalClosingDialog)="receiveSignal($event)"></app-manage-property>
  </ng-container>
</div>
<div *ngIf="mode === 'upload'">
  <ng-container *ngIf="project">
    <app-new-property [project]=project (changeModeEvent)="changeMode($event)" (uploadPropertyEvent)="addNewProperty($event)"></app-new-property>
  </ng-container>
</div>